<!--
  - Parameters
    - selectedId
      - The id of the selected data.
      - When this parameter is specified, the value is set.
  - Custom Event
    - @selected
      - Event occur when selected the list item
 -->
 <template>
  <v-select
    :options="lists"
    :filterable="false"
    v-model="selected"
    @search="onSearch"
    @search:focus="onFocus"
    @option:selected="onSelected"
    @option:deselected="onSelected"
    :getOptionLabel="option => option[this.label]"
  />
</template>

<script>
import { cloneDeep, debounce } from 'lodash'

export default {
  props: {
    selectedId: {
      type: Number,
      default: null,
    },
    additionalParams: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      lists: [],
      selected: {},
    }
  },
  async created() {
    this.setSelected(this.selectedId)
  },
  methods: {
    async getSuggestList(search, additionalParams = null) {
      const params = {}
      if (search) {
        params['name'] = search
      }
      if (additionalParams !== null) {
        for (let key in additionalParams) {
          if (!additionalParams[key]) continue
          params[key] = additionalParams[key]
        }
      }
      return await this.mixinGetAPI(
        `${this.$appConfig.CommonApiUrl}/partners`,
        params,
      )
    },
    async setSelected(selectedId) {
      if (selectedId === null) {
        this.selected = {}
        return
      }
      const params = cloneDeep(this.additionalParams)
      if (params !== null && selectedId !== null && selectedId > 0) {
        params['id'] = selectedId
      }
      this.lists = await this.getSuggestList('', params)
      if (selectedId !== null && selectedId > 0 && this.lists.length > 0) {
        this.selected = this.lists[0]
      }
    },
    async onFocus() {
      this.lists = []
      this.lists = await this.getSuggestList('', this.additionalParams)
    },
    onSearch: debounce(async function(search, loading) {
      loading(true)
      this.lists = await this.getSuggestList(search, this.additionalParams)
      loading(false)
    }, 250),
    onSelected(newVal) {
      this.$emit('selected', newVal)
    },
  },
  watch: {
    selectedId: async function(newVal) {
      this.setSelected(newVal)
    },
    selected: async function(newVal) {
      if (newVal === null) {
        this.onSelected(null)
      }
    },
  },
}

</script>
